module.exports = __webpack_public_path__ + "img/value_icon_three.8977a9d7.png";